import React from "react";
import { RefreshCw } from "lucide-react";
import integrated from "../../assets/integrated.jpg";
import scalable from "../../assets/scalable.webp";

const solutions = [
  {
    number: "01",
    title: "Integrated Technology",
    description:
      "Our systems streamline routes, reduce costs, and maximize resource utilization across your entire fleet operations.",
    image:
      integrated,
  },
  {
    number: "02",
    title: "Scalable Solutions",
    description:
      "From startups to large logistics networks, we deliver customizable solutions tailored to your specific operational needs.",
    image:
      scalable,
  },
  {
    number: "03",
    title: "Field-Tested Reliability",
    description:
      "Every product we deploy is field-tested for accuracy, uptime, and safety — ensuring consistent results in any environment.",
    image:
      "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?auto=format&fit=crop&w=900&q=80",
  },
  {
    number: "04",
    title: "Data-Driven Insights",
    description:
      "Transform your fleet data into actionable insights with our comprehensive analytics and reporting tools.",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=900&q=80",
  },
];

const SmartSolutionsOverview = () => {
  return (
    <section className="w-full bg-white ">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <div className="mx-auto mb-8 max-w-xl text-center sm:mb-10 md:mb-12">
          <h2 className="text-2xl font-bold text-black sm:text-3xl md:text-4xl mt-10">
            Why Choose Us
          </h2>

          <p className="mt-3 text-xs leading-relaxed text-gray-600 sm:mt-4 sm:text-sm md:text-base">
            We bring together GPS, fuel sensors, and telematics in one unified
            platform — built for seamless fleet automation and effective
            management.
          </p>
        </div>

        {/* Cards */}
        <div className="border-y border-gray-300">
          {solutions.map((item, index) => (
            <div
              key={item.number}
              className={`group relative isolate grid grid-cols-1 items-center gap-5 border-gray-300 px-0 py-6 before:absolute before:inset-y-0 before:left-1/2 before:-z-10 before:w-screen before:-translate-x-1/2 before:bg-transparent before:transition-colors before:duration-300 hover:before:bg-[#faf2ea] sm:grid-cols-[100px_minmax(0,1fr)] sm:gap-6 sm:px-4 sm:py-7 lg:px-6 xl:min-h-[190px] xl:grid-cols-[150px_minmax(0,1fr)_300px] xl:gap-8 ${
                index !== solutions.length - 1 ? "border-b" : ""
              }`}
            >
              {/* Number */}
              <div className="flex items-center">
                <span className="font-sans text-6xl font-semibold leading-none text-transparent [-webkit-text-stroke:1.3px_#e28a32] sm:text-7xl lg:text-8xl">
                  {item.number}
                </span>
              </div>

              {/* Content */}
              <div className="flex min-w-0 max-w-lg items-start gap-3 sm:gap-5">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[#d48635] text-white shadow-sm sm:h-11 sm:w-11">
                  <RefreshCw size={20} strokeWidth={2.4} />
                </div>

                <div className="min-w-0">
                  <h3 className="text-lg font-bold text-black sm:text-xl">
                    {item.title}
                  </h3>

                  <p className="mt-2 text-xs leading-relaxed text-gray-700 sm:mt-3 sm:text-sm">
                    {item.description}
                  </p>
                </div>
              </div>

              {/* Hover Image */}
              <div className="pointer-events-none relative h-[160px] w-full overflow-hidden rounded-lg opacity-100 shadow-md transition-all duration-300 sm:col-span-2 sm:h-[190px] xl:col-span-1 xl:h-[135px] xl:opacity-0 xl:group-hover:opacity-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="h-full w-full scale-105 object-cover transition-transform duration-500 group-hover:scale-100"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SmartSolutionsOverview;
